import { render, staticRenderFns } from "./hospitalProcess.vue?vue&type=template&id=3d74c28d&scoped=true&"
import script from "./hospitalProcess.vue?vue&type=script&lang=js&"
export * from "./hospitalProcess.vue?vue&type=script&lang=js&"
import style0 from "./hospitalProcess.vue?vue&type=style&index=0&id=3d74c28d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d74c28d",
  null
  
)

export default component.exports